// Create-alert requests answer HTTP 402 with `tier_limit_reached: true` when the
// plan's alert allowance is used up. Keep that signal on the thrown Error so the
// UI can offer an upgrade instead of only a message string.
const toCount = (value) => (Number.isInteger(value) && value >= 0 ? value : null);

export const toAlertCreateError = (error, fallbackMessage) => {
  const response = error?.response;
  const status = response?.status;
  const err = new Error(response?.data?.message || error?.message || fallbackMessage);
  err.status = status;
  err.tierLimitReached = status === 402 || response?.data?.tier_limit_reached === true;
  // Server-reported usage ("1/1"); null when absent so 0 allowance is kept distinct.
  err.currentAlertCount = toCount(response?.data?.current_alert_count);
  err.maxAllowedAlerts = toCount(response?.data?.max_allowed_alerts);
  return err;
};

export const isTierLimitError = (error) => error?.tierLimitReached === true;
